import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import InstituteTemplate from "../../Components/InstituteTemplate/InstituteTemplate";
import DesktopTabsForScheduledClasses from "./DesktopTabsforSchduleClasses/DesktopTopTabsForScheduleClasses";
import { CreateScheduleA, GetClassScheduleA, GetUserByIdA } from "../../Actions/StudentA";
import { GetAboutInfoA, GetInstituteCoursesTimeSlots } from "../../Actions/CourseA";
import { BaseUrl } from "../../Actions/Base";
import { GetInstituteSideCoursesTimeSlots } from "../../Actions/CourseA";
import AboutClient from "./AboutClient/AboutClient";
import ScheduleAndInstructorTab from "./ScheduleAndInstructorTab/ScheduleAndInstructorTab";
import { GetCourseInstructorA, GetInstructorsA } from "../../Actions/InstructorA";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";

const ManageNewStudentChild= () => {
    const Dispatch = useDispatch();
       
    const [activeTab, setActiveTab] = useState("AboutClient");
    const { EnrollmentId } = useParams();
    const { Student, ScheduleTimeTable, loading, CoursePackage, StudentInfo } = useSelector(
        (Store) => Store.StudentReducer
      );
    const { Instructors, CourseInstructors } = useSelector(Store => Store.InstructorReducer)
    const { timeSlots } = useSelector((Store) => Store.CourseReducer);
    console.log("timeslots are:",timeSlots)
    
    console.log("ScheduleTimeTable", ScheduleTimeTable)
    console.log("Student", Student);
    console.log("CoursePackage", CoursePackage);
    console.log("StudentInfo", StudentInfo);
    console.log("CourseInstructorsss", CourseInstructors)

    const InstituteCourseId = StudentInfo?.InstituteCourseFK;

    useEffect(() => {
        if (EnrollmentId) {
            Dispatch(GetClassScheduleA(EnrollmentId)); 
            Dispatch(GetAboutInfoA(EnrollmentId)); 
            Dispatch(GetInstructorsA(EnrollmentId))
            Dispatch(GetCourseInstructorA(EnrollmentId))
        }
      }, [Dispatch, EnrollmentId]); // Add `userId` if it's used in the effect

    useEffect(() => {
        if (InstituteCourseId) {
            Dispatch(GetInstituteCoursesTimeSlots(InstituteCourseId)); // Pass the state
        }
      }, [Dispatch, InstituteCourseId]); // Add `userId` if it's used in the effect

     // Function to render the right-side content based on the active tab
    const renderContent = () => {
         switch (activeTab) {
            case "AboutClient":
                  return <AboutClient Student={Student} StudentInfo={StudentInfo} setActiveTab={setActiveTab} />;
            case "ScheduleAndInstructor":
                  return <ScheduleAndInstructorTab Student={Student} StudentInfo={StudentInfo} setActiveTab={setActiveTab}
                   CourseInstructors={CourseInstructors} ScheduleTimeTable={ScheduleTimeTable} CoursePackage={CoursePackage} EnrollmentId={EnrollmentId}
                   timeSlots={timeSlots} /> ;
            default:
             return <AboutClient Student={Student} StudentInfo={StudentInfo} setActiveTab={setActiveTab} />;
         }
     };
    
    return (
        <>
         {!loading ? (
              <>
                <DesktopTabsForScheduledClasses setActiveTab={setActiveTab} activeTab={activeTab} CoursePackage={CoursePackage} />
                <div className="mt-[50px] pb-[100px]">
                    {renderContent()}
                </div>
              </>
         ) :  (
              <LoadingSpinner
              Height="[500px]"
              Width="[99%]"
              Top="[80px]"
              Left="0"
              Position="relative"
            />
         )}
        </>
    );
};


const SchedulingNewStudentClasses = () => (
    <InstituteTemplate
      Element={ManageNewStudentChild}
      m_top="mt-0"
      bg="bg-[#F0F0F7]"
    />
  );

export default SchedulingNewStudentClasses;
